// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TabPanel_wrap__6ePAP","visible":"TabPanel_visible__V3pNh"};